import styled from 'styled-components';

export const AboutWrapper = styled.main`
  background: #f7f8fa;
  color: #1f242b;
`;

export const AboutHero = styled.section`
  background: #1f242b;
  color: #ffffff;
  padding: clamp(3rem, 7vw, 6rem) max(1.25rem, calc((100vw - 1180px) / 2 + 1.25rem));

  p {
    color: #60a5fa;
    font-size: 0.82rem;
    font-weight: 900;
    letter-spacing: 0;
    margin: 0 0 0.85rem;
    text-transform: uppercase;
  }

  h1 {
    color: #ffffff;
    font-size: clamp(2.05rem, 5vw, 4.2rem);
    line-height: 1.02;
    margin: 0 0 1rem;
    max-width: 860px;
    overflow-wrap: break-word;
  }

  span {
    color: #dbe4ee;
    display: block;
    font-size: 1.1rem;
    line-height: 1.75;
    max-width: 760px;
  }
`;

export const AboutContent = styled.div`
  margin: 0 auto;
  max-width: 1180px;
  padding: clamp(3rem, 6vw, 5.5rem) 1.25rem;
`;

export const AboutTextGrid = styled.div`
  align-items: start;
  display: grid;
  gap: 1.5rem;
  grid-template-columns: minmax(0, 1.4fr) minmax(280px, 0.6fr);
  margin-bottom: clamp(3rem, 6vw, 5rem);

  h2 {
    color: #1f242b;
    font-size: clamp(1.7rem, 3vw, 2.6rem);
    line-height: 1.12;
    margin: 0 0 1rem;
    overflow-wrap: break-word;
  }

  p {
    color: #586271;
    font-size: 1.04rem;
    line-height: 1.75;
    margin: 0 0 1rem;
  }

  @media (max-width: 850px) {
    grid-template-columns: 1fr;
  }
`;

export const ServiceAreaPanel = styled.aside`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 18px 38px rgba(17, 24, 39, 0.07);
  padding: 1.35rem;

  h2 {
    font-size: 1.35rem;
    margin-bottom: 0.6rem;
  }

  p {
    margin-bottom: 1rem;
  }

  ul {
    display: grid;
    gap: 0.55rem;
    list-style: none;
    margin: 0 0 1.15rem;
    padding: 0;
  }

  li {
    color: #374151;
    font-weight: 800;
    padding-left: 1.05rem;
    position: relative;
  }

  li::before {
    background: #2563eb;
    border-radius: 999px;
    content: '';
    height: 0.45rem;
    left: 0;
    position: absolute;
    top: 0.55rem;
    width: 0.45rem;
  }

  a {
    color: #1d4ed8;
    font-weight: 900;
    text-decoration: none;
  }
`;

export const GalleryIntro = styled.div`
  margin-bottom: 1.5rem;
  max-width: 780px;

  p {
    color: #1d4ed8;
    font-size: 0.82rem;
    font-weight: 900;
    letter-spacing: 0;
    margin: 0 0 0.75rem;
    text-transform: uppercase;
  }

  h2 {
    color: #1f242b;
    font-size: clamp(1.75rem, 4vw, 3rem);
    line-height: 1.08;
    margin: 0 0 0.85rem;
    overflow-wrap: break-word;
  }

  span {
    color: #586271;
    display: block;
    font-size: 1.05rem;
    line-height: 1.75;
  }
`;

export const GalleryWrapper = styled.section`
  display: grid;
  gap: 1.25rem;
`;

export const GalleryItem = styled.div`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 18px 38px rgba(17, 24, 39, 0.07);
  display: grid;
  gap: 0;
  grid-template-columns: minmax(240px, 0.38fr) minmax(0, 0.62fr);
  overflow: hidden;

  > div:first-child {
    align-content: center;
    display: grid;
    padding: 1.4rem;
  }

  h3 {
    color: #1f242b;
    font-size: 1.35rem;
    margin: 0 0 0.55rem;
  }

  p {
    color: #586271;
    line-height: 1.7;
    margin: 0;
  }

  .image-gallery {
    width: 100%;
  }

  .image-gallery-slide img {
    aspect-ratio: 16 / 9;
    display: block;
    height: 100%;
    object-fit: cover;
    width: 100%;
  }

  .image-gallery-thumbnail {
    border: 3px solid transparent;
    border-radius: 6px;
    overflow: hidden;
  }

  .image-gallery-thumbnail.active,
  .image-gallery-thumbnail:focus,
  .image-gallery-thumbnail:hover {
    border-color: #2563eb;
  }

  .image-gallery-thumbnail-image {
    height: 58px;
    object-fit: cover;
  }

  @media (max-width: 850px) {
    grid-template-columns: 1fr;
  }
`;

export const AboutCTA = styled.section`
  background: #1f242b;
  border-radius: 8px;
  color: #ffffff;
  margin-top: clamp(2.25rem, 5vw, 4rem);
  padding: clamp(2rem, 5vw, 3.25rem);
  text-align: center;

  h2 {
    color: #ffffff;
    font-size: clamp(1.8rem, 4vw, 2.8rem);
    line-height: 1.1;
    margin: 0 0 0.85rem;
  }

  p {
    color: #dbe4ee;
    line-height: 1.7;
    margin: 0 auto 1.35rem;
    max-width: 660px;
  }

  a {
    background: #2563eb;
    border-radius: 8px;
    color: #ffffff;
    display: inline-flex;
    font-weight: 900;
    justify-content: center;
    min-height: 48px;
    padding: 0.85rem 1.2rem;
    text-decoration: none;
  }

  @media (max-width: 520px) {
    a {
      width: 100%;
    }
  }
`;
